import { render, staticRenderFns } from "./Outcome.vue?vue&type=template&id=3a4877fe"
import script from "./Outcome.js?vue&type=script&lang=js&external"
export * from "./Outcome.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports